import PayPalFooter from './paypal_footer'
import { connect } from 'react-redux'
import { isLoggedInSelector } from 'redux/selectors/login'

function switchableLanguages(languages) {
  const lang = document.documentElement.getAttribute('lang')
  return languages.filter(l => l.code !== lang)
}

const mapStateToProps = (state, ownProps) => {
  return {
    linksConfig: state.links,
    userConfig: state.user_config,
    groupFeatures: state.group_features,
    country: state.country.country_code,
    locale: state.country.locale,
    showLanguageSelection: !isLoggedInSelector(state),
    languages: switchableLanguages(state.country.languages),
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PayPalFooter)
